import { ContentTile, Icon } from "../../lib";

import React from "react";

export default () => (
  <ContentTile label="hi there">
    <Icon />
  </ContentTile>);



// WEBPACK FOOTER //
// ./src/ContentTile/demo/stateless.js